class BackToTop extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 400;
    this.button = this.querySelector('.back-to-top__button');
    this.ticking = false;

    this.hidden = false;

    this._onScroll = this._onScroll.bind(this);
    this._onClick = this._onClick.bind(this);

    window.addEventListener('scroll', this._onScroll, { passive: true });
    this.button?.addEventListener('click', this._onClick);

    this._update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    this.button?.removeEventListener('click', this._onClick);
  }

  _onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this._update();
      this.ticking = false;
    });
  }

  _update() {
    const shouldShow = window.scrollY > this.threshold;
    this.classList.toggle('is-visible', shouldShow);
  }

  _onClick() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
